// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { IArticleInsertProcessor } from './i-article-insert.processor';
import { CompositeArticleUtils } from '@article/util/composite-article-utils';
import { ArticleUtils } from '@article/util/article-utils';
import { DefaultArticleInsertProcessor } from './default-article-insert.processor';
import { CompositeMultipleBaseArticleInsertProcessor } from './composite-multiple-base-article-insert.processor';
import { CoverLabelStripArticleInsertProcessor } from './cover-label-strip-article-insert.processor';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ArticleInsertProcessorRegistry {

  private _defaultInsertProcessor: DefaultArticleInsertProcessor;
  private _compositeMultipleBaseInsertProcessor: CompositeMultipleBaseArticleInsertProcessor;
  private _coverLabelStripArticleInsertProcessor: CoverLabelStripArticleInsertProcessor;
  private initialized = false;

  constructor(
    private compositeArticleUtils: CompositeArticleUtils
  ) {}

  public initialize(defaultInsertProcessor: DefaultArticleInsertProcessor,
                    compositeMultipleBaseInsertProcessor: CompositeMultipleBaseArticleInsertProcessor,
                    coverLabelStripArticleInsertProcessor: CoverLabelStripArticleInsertProcessor,) {
    this._defaultInsertProcessor = defaultInsertProcessor;
    this._compositeMultipleBaseInsertProcessor = compositeMultipleBaseInsertProcessor;
    this._coverLabelStripArticleInsertProcessor = coverLabelStripArticleInsertProcessor;
    this.initialized = true;
  }

  public get(article: ArticleVO): IArticleInsertProcessor {

    if(!this.initialized) {
      throw new Error("ArticleInsertProcessorRegistry not initialized!");
    }

    if (this.compositeArticleUtils.isCompositeMultipleBaseArticle(article)) {
      return this._compositeMultipleBaseInsertProcessor;
    } else if (ArticleUtils.isCoverLabelStripArticle(article)) {
      return this._coverLabelStripArticleInsertProcessor;
    } else {
      return this._defaultInsertProcessor;
    }
  }
}
